<template>
    <v-card>
        <v-card-text>
            <v-form :submit="getCashierBalance">
                <v-row align="center" v-if="cashier">
                    <v-col cols="5">
                        <v-text-field
                                      label="Caixa"
                                      density="compact"
                                      variant="solo"
                                      :modelValue="cashier?.name"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Último Fechamento"
                                      density="compact"
                                      variant="solo"
                                      :modelValue="cashier?.last_closing ? $moment.parseZone(cashier.last_closing).format('DD/MM/YYYY') : 'N/D'"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Saldo Atual"
                                      density="compact"
                                      variant="solo"
                                      :color="cashier.amount >= 0 ? 'green' : 'red'"
                                      :base-color="cashier.amount >= 0 ? 'green' : 'red'"
                                      :modelValue="$filters.currency(cashier.amount, 'BRL')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field type="date"
                                      label="Fechar em"
                                      density="compact"
                                      :rules="[rules.required, rules.lastClosing].flat()"
                                      v-model="closeDate"
                                      @update:modelValue="balance = null"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn icon
                               variant="text"
                               color="primary"
                               type="submit">
                            <v-icon class="mr-2">mdi-eye</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <v-form :submit="closeCashierBalance">
                <v-row align="center" v-if="balance">
                    <v-col cols="2">
                        <v-text-field
                                      label="Início"
                                      density="compact"
                                      variant="solo"
                                      :modelValue="$moment.parseZone(balance.start_at).format('DD/MM/YYYY')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Saldo Inicial"
                                      density="compact"
                                      variant="solo"
                                      :color="balance.starting_amount >= 0 ? 'green' : 'red'"
                                      :base-color="balance.starting_amount >= 0 ? 'green' : 'red'"
                                      :modelValue="$filters.currency(balance.starting_amount, 'BRL')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Final"
                                      density="compact"
                                      variant="solo"
                                      :modelValue="$moment.parseZone(balance.end_at).format('DD/MM/YYYY')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Saldo Final"
                                      density="compact"
                                      variant="solo"
                                      :color="balance.ending_amount >= 0 ? 'green' : 'red'"
                                      :base-color="balance.ending_amount >= 0 ? 'green' : 'red'"
                                      :modelValue="$filters.currency(balance.ending_amount, 'BRL')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                                      label="Variação"
                                      density="compact"
                                      variant="solo"
                                      :color="balance.variation >= 0 ? 'green' : 'red'"
                                      :base-color="balance.variation >= 0 ? 'green' : 'red'"
                                      :modelValue="$filters.currency(balance.variation, 'BRL')"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="secondary"
                               type="submit"
                               :disabled="cashier?.last_closing >= closeDate">
                            <v-icon class="mr-2">mdi-close</v-icon>
                            Fechar Caixa
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
import api from '@/services'

export default {
    data() {
        return {
            requestingApi: false,
            balance: null,
            closeDate: this.$moment.parseZone().format('YYYY-MM-DD'),
            rules: {
                required: [(v) => !!v || "Campo obrigatório"],
                lastClosing: [(v) => this.cashier?.last_closing < v || 'Data deve ser maior que último fechamento']
            },
        }
    },
    emits: ['cashier:closed'],
    methods: {
        getCashierBalance() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.cashier.balanceSinceLastClosing({
                        cashier_id: vm.cashier.id,
                        end_date: vm.closeDate
                    }).then(result => {
                        vm.balance = result;
                        resolve(result);
                    }).catch(err => {
                        if (err.message) {
                            vm.$notify({
                                type: "error",
                                text: err.message,
                            });
                        }
                        reject(err.message);
                    }).finally(() => {
                        vm.requestingApi = false;
                    });
                });
            }
        },
        closeCashierBalance() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.cashier.updateOrCreate({
                        ...vm.cashier,
                        last_closing: vm.closeDate
                    }).then(result => {
                        vm.$notify({
                            type: "success",
                            text: 'Caixa fechado com sucesso em ' + vm.$moment.parseZone(vm.closeDate).format("DD/MM/YYYY"),
                        });
                        vm.$emit('cashier:closed');
                        resolve(result);
                    }).catch(err => {
                        if (err.message) {
                            vm.$notify({
                                type: "error",
                                text: err.message,
                            });
                        }
                        reject(err.message);
                    }).finally(() => {
                        vm.requestingApi = false;
                    });
                });
            }
        }
    },
    props: {
        user: Object,
        cashier: Object,
    },
    watch: {
        cashier: {
            handler(newVal, oldVal) {
                const vm = this;

                if (newVal && !oldVal) {
                }
            },
            imediate: true
        }
    }
}
</script>